// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Footer.css - Footer组件样式 */

footer {
  padding: 40px;
  text-align: center;
  border-top: 1px solid #1a2235;
  color: #718096;
  font-size: 0.8rem;
  letter-spacing: 1px;
  position: relative;
}

footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 150px;
  height: 1px;
  background: linear-gradient(90deg,
    transparent,
    rgba(0, 229, 255, 0.5),
    transparent);
}

footer p {
  margin: 0;
}

/* 响应式设计 */
@media (max-width: 768px) {
  footer {
    padding: 30px 20px;
    font-size: 0.75rem;
  }
}

@media (max-width: 480px) {
  footer {
    padding: 25px 15px;
    font-size: 0.7rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA,4BAA4B;;AAE5B;EACE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX;;;gBAGc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA,UAAU;AACV;EACE;IACE,kBAAkB;IAClB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,iBAAiB;EACnB;AACF","sourcesContent":["/* Footer.css - Footer组件样式 */\n\nfooter {\n  padding: 40px;\n  text-align: center;\n  border-top: 1px solid #1a2235;\n  color: #718096;\n  font-size: 0.8rem;\n  letter-spacing: 1px;\n  position: relative;\n}\n\nfooter::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 150px;\n  height: 1px;\n  background: linear-gradient(90deg,\n    transparent,\n    rgba(0, 229, 255, 0.5),\n    transparent);\n}\n\nfooter p {\n  margin: 0;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  footer {\n    padding: 30px 20px;\n    font-size: 0.75rem;\n  }\n}\n\n@media (max-width: 480px) {\n  footer {\n    padding: 25px 15px;\n    font-size: 0.7rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
